import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_13 = { class: "alert alert-success mb-4" }
const _hoisted_14 = { class: "mb-0 mt-2" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = {
  key: 1,
  class: "row"
}
const _hoisted_31 = { class: "col-md-12" }
const _hoisted_32 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_33 = {
  key: 0,
  class: "row"
}
const _hoisted_34 = {
  key: 0,
  class: "row"
}
const _hoisted_35 = { class: "col-md-3" }
const _hoisted_36 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_37 = { class: "col-md-3" }
const _hoisted_38 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_39 = { class: "col-md-3" }
const _hoisted_40 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_41 = { class: "col-md-3" }
const _hoisted_42 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_47 = {
  key: 1,
  class: "row"
}
const _hoisted_48 = { class: "col-md-12 mb-2" }
const _hoisted_49 = { class: "alert alert-success" }
const _hoisted_50 = { class: "col-md-4" }
const _hoisted_51 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_52 = { class: "col-md-4" }
const _hoisted_53 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_54 = { class: "col-md-4" }
const _hoisted_55 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_56 = { class: "col-md-4" }
const _hoisted_57 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_58 = { class: "text-muted" }
const _hoisted_59 = { class: "col-md-4" }
const _hoisted_60 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_61 = {
  key: 2,
  class: "row"
}
const _hoisted_62 = { class: "col-md-4" }
const _hoisted_63 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_64 = { class: "col-md-4" }
const _hoisted_65 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_66 = { class: "col-md-4" }
const _hoisted_67 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_68 = { class: "col-md-4" }
const _hoisted_69 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_70 = { class: "col-md-4" }
const _hoisted_71 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_72 = { class: "col-md-4" }
const _hoisted_73 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_74 = { class: "col-md-12" }
const _hoisted_75 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_76 = { class: "d-flex flex-wrap gap-5 align-items-center" }
const _hoisted_77 = { class: "form-check" }
const _hoisted_78 = { class: "form-check" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { class: "col-md-4" }
const _hoisted_81 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_82 = { class: "col-md-12" }
const _hoisted_83 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_84 = { class: "col-md-12 mt-4" }
const _hoisted_85 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.addPricingRule,
        "validation-schema": _ctx.pricingRuleSchema,
        ref: "pricingRuleForm"
      }, {
        default: _withCtx(({ values }) => [
          _createElementVNode("div", _hoisted_3, [
            _cache[51] || (_cache[51] = _createElementVNode("div", { class: "col-md-12 mb-3" }, [
              _createElementVNode("div", { class: "alert alert-primary" }, [
                _createElementVNode("strong", null, "Étape 1 :"),
                _createTextVNode(" Informations de base de la règle de tarification ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Code "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "code",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Ex: BESC-BJ-DOSSIER"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "code",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Nom "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "name",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Ex: Frais de dossier"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "name",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Zone Tarifaire "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "tariffZoneId" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.tariffZoneOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner la zone" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "tariffZoneId",
                  class: "text-danger"
                })
              ])
            ]),
            _cache[52] || (_cache[52] = _createElementVNode("div", { class: "col-md-12 mt-3 mb-3" }, [
              _createElementVNode("div", { class: "alert alert-info" }, [
                _createElementVNode("strong", null, "Étape 2 :"),
                _createTextVNode(" Sur quel élément cette règle doit-elle s'appliquer ? ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Type d'entité "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "appliesToEntityType" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.entityTypeOptions,
                      searchable: false,
                      "track-by": "label",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      onChange: _ctx.onEntityTypeChange,
                      placeholder: "Choisissez le type d'entité..."
                    }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "appliesToEntityType",
                  class: "text-danger"
                })
              ])
            ]),
            (_ctx.selectedEntityType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.entityTypeHelp.title), 1),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.entityTypeHelp.description), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedEntityType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col-md-12 mt-3 mb-3" }, [
                    _createElementVNode("div", { class: "alert alert-warning" }, [
                      _createElementVNode("strong", null, "Étape 3 :"),
                      _createTextVNode(" Configuration principale de la règle (obligatoire) ")
                    ])
                  ], -1)),
                  (_ctx.selectedEntityType === 'CONTAINER')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-12 mb-2" }, [
                          _createElementVNode("div", { class: "alert alert-success" }, [
                            _createElementVNode("strong", null, "Tarification Conteneurs (FCL)")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Taille de la tranche "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "trancheSize",
                              type: "number",
                              class: "form-control",
                              placeholder: "5"
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "trancheSize",
                              class: "text-danger"
                            }),
                            _cache[5] || (_cache[5] = _createElementVNode("small", { class: "text-muted" }, "Nombre de conteneurs par tranche (ex: 5)", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Unité de mesure "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "unitOfMeasure" }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(_component_Multiselect, _mergeProps({
                                  options: _ctx.unitOfMeasureOptions,
                                  searchable: false,
                                  "track-by": "label",
                                  label: "label",
                                  modelValue: field.value,
                                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                }, field, { disabled: true }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "unitOfMeasure",
                              class: "text-danger"
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "unitOfMeasure",
                              class: "text-danger"
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Max par ECTN ", -1)),
                            _createVNode(_component_Field, {
                              name: "maxPerEctn",
                              type: "number",
                              class: "form-control",
                              placeholder: "Illimité"
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "maxPerEctn",
                              class: "text-danger"
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Tarif applicable "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "amountForOrigin",
                              type: "number",
                              step: "0.01",
                              class: "form-control",
                              placeholder: "25"
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "amountForOrigin",
                              class: "text-danger"
                            }),
                            _createElementVNode("small", _hoisted_25, "Par tranche de " + _toDisplayString(values.trancheSize || 5) + " conteneurs", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Devise "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "amountCurrency" }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(_component_Multiselect, _mergeProps({
                                  options: _ctx.currencyOptions,
                                  searchable: true,
                                  "track-by": "label",
                                  label: "label",
                                  modelValue: field.value,
                                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                }, field), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "amountCurrency",
                              class: "text-danger"
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Types de conteneur "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "metadata.containerTypes" }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(_component_Multiselect, _mergeProps({
                                  options: _ctx.containerTypeOptions,
                                  searchable: true,
                                  mode: "tags",
                                  modelValue: field.value,
                                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                }, field, { placeholder: "Sélectionner un ou plusieurs types" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "metadata.containerTypes",
                              class: "text-danger"
                            }),
                            _cache[11] || (_cache[11] = _createElementVNode("small", { class: "text-muted" }, "Obligatoire : choisissez les types concernés", -1))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedEntityType === 'GOODS')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col-md-12 mb-3" }, [
                          _createElementVNode("div", { class: "alert alert-info" }, [
                            _createElementVNode("strong", null, "Marchandises avec conditionnement"),
                            _createElementVNode("p", { class: "mb-0 mt-2" }, " Sélectionnez le type de conditionnement pour appliquer la grille tarifaire correspondante ")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Type de conditionnement "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "packagingType" }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(_component_Multiselect, _mergeProps({
                                  options: _ctx.packagingTypeOptions,
                                  searchable: false,
                                  "track-by": "label",
                                  label: "label",
                                  modelValue: field.value,
                                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                }, field, {
                                  onChange: _ctx.onPackagingTypeChange,
                                  placeholder: "Choisissez le type de conditionnement..."
                                }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onChange"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "packagingType",
                              class: "text-danger"
                            })
                          ])
                        ]),
                        (_ctx.selectedPackagingType)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              (_ctx.selectedPackagingType === 'ROULANT')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-md-12 mb-2" }, [
                                      _createElementVNode("div", { class: "alert alert-success" }, [
                                        _createElementVNode("strong", null, "Tarification Roulant")
                                      ])
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Poids minimum (tonnes) "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "minWeight",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control shadow-none fs-md-15 text-black"
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "minWeight",
                                          class: "text-danger"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("div", _hoisted_38, [
                                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Poids maximum (tonnes) "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "maxWeight",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control shadow-none fs-md-15 text-black"
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "maxWeight",
                                          class: "text-danger"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_39, [
                                      _createElementVNode("div", _hoisted_40, [
                                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Unité de mesure "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, { name: "unitOfMeasure" }, {
                                          default: _withCtx(({ field }) => [
                                            _createVNode(_component_Multiselect, _mergeProps({
                                              options: _ctx.unitOfMeasureOptions,
                                              searchable: false,
                                              "track-by": "label",
                                              label: "label",
                                              modelValue: field.value,
                                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                            }, field, { disabled: true }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "unitOfMeasure",
                                          class: "text-danger"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                      _createElementVNode("div", _hoisted_42, [
                                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Max par ECTN "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "maxPerEctn",
                                          type: "number",
                                          class: "form-control shadow-none fs-md-15 text-black",
                                          placeholder: "1"
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "maxPerEctn",
                                          class: "text-danger"
                                        }),
                                        _cache[18] || (_cache[18] = _createElementVNode("small", { class: "text-muted" }, "Ex: 1 véhicule maximum par ECTN", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Tarif applicable "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "amountForOrigin",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control",
                                          placeholder: "25"
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountForOrigin",
                                          class: "text-danger"
                                        }),
                                        _cache[20] || (_cache[20] = _createElementVNode("small", { class: "text-muted" }, "Par véhicule", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                      _createElementVNode("div", _hoisted_46, [
                                        _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Devise "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, { name: "amountCurrency" }, {
                                          default: _withCtx(({ field }) => [
                                            _createVNode(_component_Multiselect, _mergeProps({
                                              options: _ctx.currencyOptions,
                                              searchable: true,
                                              "track-by": "label",
                                              label: "label",
                                              modelValue: field.value,
                                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                            }, field), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountCurrency",
                                          class: "text-danger"
                                        })
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (['GROUPAGE', 'CONVENTIONNEL', 'VRAC'].includes(_ctx.selectedPackagingType))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("strong", null, "Tarification " + _toDisplayString(_ctx.selectedPackagingType === 'GROUPAGE' ? 'Groupage' :
                          _ctx.selectedPackagingType === 'CONVENTIONNEL' ? 'Conventionnel/Vrac' :
                            'Vrac navire complet'), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                      _createElementVNode("div", _hoisted_51, [
                                        _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Taille de la tranche (m/t) "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "trancheSize",
                                          type: "number",
                                          class: "form-control shadow-none fs-md-15 text-black",
                                          placeholder: "300"
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "trancheSize",
                                          class: "text-danger"
                                        }),
                                        _cache[24] || (_cache[24] = _createElementVNode("small", { class: "text-muted" }, "Tonnes métriques par tranche (ex: 300)", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_52, [
                                      _createElementVNode("div", _hoisted_53, [
                                        _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Unité de mesure "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, { name: "unitOfMeasure" }, {
                                          default: _withCtx(({ field }) => [
                                            _createVNode(_component_Multiselect, _mergeProps({
                                              options: _ctx.unitOfMeasureOptions,
                                              searchable: false,
                                              "track-by": "label",
                                              label: "label",
                                              modelValue: field.value,
                                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                            }, field, { disabled: true }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "unitOfMeasure",
                                          class: "text-danger"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_54, [
                                      _createElementVNode("div", _hoisted_55, [
                                        _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Max par ECTN (m/t) "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "maxPerEctn",
                                          type: "number",
                                          class: "form-control shadow-none fs-md-15 text-black",
                                          placeholder: "300"
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "maxPerEctn",
                                          class: "text-danger"
                                        }),
                                        _cache[27] || (_cache[27] = _createElementVNode("small", { class: "text-muted" }, "Ex: 300 tonnes maximum par ECTN", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _createElementVNode("div", _hoisted_57, [
                                        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Tarif applicable "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "amountForOrigin",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control shadow-none fs-md-15 text-black",
                                          placeholder: "25"
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountForOrigin",
                                          class: "text-danger"
                                        }),
                                        _createElementVNode("small", _hoisted_58, "Par tranche de " + _toDisplayString(values.trancheSize || 300) + " m/t", 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_59, [
                                      _createElementVNode("div", _hoisted_60, [
                                        _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Devise "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, { name: "amountCurrency" }, {
                                          default: _withCtx(({ field }) => [
                                            _createVNode(_component_Multiselect, _mergeProps({
                                              options: _ctx.currencyOptions,
                                              searchable: true,
                                              "track-by": "label",
                                              label: "label",
                                              modelValue: field.value,
                                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                            }, field), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountCurrency",
                                          class: "text-danger"
                                        })
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedEntityType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _cache[50] || (_cache[50] = _createElementVNode("div", { class: "col-md-12 mt-4 mb-3" }, [
                    _createElementVNode("div", { class: "alert alert-secondary" }, [
                      _createElementVNode("strong", null, "Étape 4 :"),
                      _createTextVNode(" Options avancées (facultatif) ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date de début", -1)),
                      _createVNode(_component_Field, {
                        name: "effectiveFrom",
                        type: "date",
                        class: "form-control shadow-none fs-md-15 text-black"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "effectiveFrom",
                        class: "text-danger"
                      }),
                      _cache[33] || (_cache[33] = _createElementVNode("small", { class: "text-muted" }, "Laissez vide pour appliquer immédiatement", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date de fin", -1)),
                      _createVNode(_component_Field, {
                        name: "effectiveTo",
                        type: "date",
                        class: "form-control shadow-none fs-md-15 text-black"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "effectiveTo",
                        class: "text-danger"
                      }),
                      _cache[35] || (_cache[35] = _createElementVNode("small", { class: "text-muted" }, "Laissez vide pour \"sans limite\"", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Priorité", -1)),
                      _createVNode(_component_Field, { name: "priority" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.priorityOptions,
                            searchable: false,
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Normale (100) par défaut" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "priority",
                        class: "text-danger"
                      }),
                      _cache[37] || (_cache[37] = _createElementVNode("small", { class: "text-muted" }, "Plus le nombre est bas, plus prioritaire", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _cache[38] || (_cache[38] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Régime douanier (optionnel)", -1)),
                      _createVNode(_component_Field, { name: "regimedouanierId" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.regimeDouanierOptions,
                            searchable: true,
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner un régime" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Montant min facturé", -1)),
                      _createVNode(_component_Field, {
                        name: "minFeeAmount",
                        type: "number",
                        step: "0.01",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Ex: 1000"
                      }),
                      _cache[40] || (_cache[40] = _createElementVNode("small", { class: "text-muted" }, "Plafond minimum", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _cache[41] || (_cache[41] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Montant max facturé", -1)),
                      _createVNode(_component_Field, {
                        name: "maxFeeAmount",
                        type: "number",
                        step: "0.01",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Ex: 100000"
                      }),
                      _cache[42] || (_cache[42] = _createElementVNode("small", { class: "text-muted" }, "Plafond maximum", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(_component_Field, {
                            name: "isExemptionRule",
                            type: "checkbox",
                            class: "form-check-input",
                            id: "isExemptionRule",
                            value: true
                          }),
                          _cache[43] || (_cache[43] = _createElementVNode("label", {
                            class: "form-check-label text-black fw-semibold",
                            for: "isExemptionRule"
                          }, " Règle d'exemption (réduction) ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _createVNode(_component_Field, {
                            name: "isActive",
                            type: "checkbox",
                            class: "form-check-input",
                            id: "isActive",
                            value: true,
                            checked: ""
                          }),
                          _cache[44] || (_cache[44] = _createElementVNode("label", {
                            class: "form-check-label text-black fw-semibold",
                            for: "isActive"
                          }, " Activer cette règle immédiatement ", -1))
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.pricingRuleForm?.values?.isExemptionRule)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _cache[45] || (_cache[45] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Taux d'exemption (%) ", -1)),
                            _createVNode(_component_Field, {
                              name: "exemptionRate",
                              type: "number",
                              step: "0.01",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Ex: 10"
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "exemptionRate",
                              class: "text-danger"
                            }),
                            _cache[46] || (_cache[46] = _createElementVNode("small", { class: "text-muted" }, "% de réduction", -1))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _cache[47] || (_cache[47] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Description", -1)),
                      _createVNode(_component_Field, {
                        name: "description",
                        as: "textarea",
                        rows: "3",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Décrivez cette règle en détail..."
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _cache[49] || (_cache[49] = _createElementVNode("button", {
                        type: "submit",
                        class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                      }, " Ajouter la règle ", -1)),
                      _createVNode(_component_router_link, {
                        to: "/listeBescPricingRule",
                        class: "btn btn-danger transition border-0 lh-1 fw-medium pt-10 pb-10 ps-25 pe-25"
                      }, {
                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                          _createTextVNode(" Annuler ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}